import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "flex gap-2 flex-row flex-wrap card-container blue-container" }
const _hoisted_3 = { class: "align-items-center justify-content-center" }
const _hoisted_4 = { for: "GemProjectField:rootProject" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "align-items-center justify-content-center" }
const _hoisted_8 = { for: "GemProjectField:project" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "align-items-center justify-content-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "GemProjectField:tags" }, "Tag", -1)

import Dropdown, {DropdownChangeEvent} from "primevue/dropdown";
import {AxiosStatic} from "axios";
import {inject, onMounted, ref, withDefaults} from "vue";
import {GemProject} from "@/components/blocks/Types";

// Define types
type Props = {
  rootProject: any | null,
  project: any | null,
  tag: any | null,
  vualidate?: any | null,
  submitted: boolean

}

//  Define emits

export default /*#__PURE__*/_defineComponent({
  __name: 'GemProjectField',
  props: {
    rootProject: { default: null },
    project: { default: null },
    tag: { default: null },
    vualidate: null,
    submitted: { type: Boolean, default: false }
  },
  emits: ['update:rootProject', 'update:project', 'update:tag'],
  setup(__props: any, { emit: emits }) {

const props = __props as { rootProject: any | null, project: any | null, tag: any | null, vualidate?: any | null, submitted: boolean };



// Define input props


// Define injects
const axios = inject<AxiosStatic>('axios')

// Define props
const gmRootProject = ref<GemProject[]>([])
const gmProject = ref<GemProject[]>([])
const gmTags = ref<GemProject[]>([])

const selectedRootProject = ref<GemProject | null>(null)
const selectedProject = ref<GemProject | null>(null)
const selectedTag = ref<GemProject | null>(null)

// Define lifecycle hooks
onMounted(() => {
  axios?.get("/gem-timesheet-resource/list").then(response => {
    if (response.status >= 200 && response.status <= 299) {
      gmRootProject.value = response.data
    } else {
      console.error('Can not load GEM Timesheet project settings', response)
    }
  })
})

// Define methods
function handleRootProjectChange(event: DropdownChangeEvent) {
  gmProject.value = []
  gmTags.value = []

  selectedProject.value = null
  selectedTag.value = null

  if (event.value && event.value.projects) {
    gmProject.value = event.value.projects

    const _rootProject = {
      text: selectedRootProject.value?.text,
      id: selectedRootProject.value?.key
    }
    const eventData = {
      rootProject: _rootProject,
      project: null,
      tag: null
    }

    emits('update:rootProject', eventData.rootProject)
    emits('update:project', null)
    emits('update:tag', null)
  } else {

    emits('update:rootProject', null)
    emits('update:project', null)
    emits('update:tag', null)
  }
}

function handleProjectChange(event: DropdownChangeEvent) {
  selectedTag.value = null
  gmTags.value = event.value?.tags
  const _rootProject = {
    text: selectedRootProject.value?.text,
    id: selectedRootProject.value?.key
  }

  if (event.value) {
    const _project = {
      text: selectedProject.value?.text,
      id: selectedProject.value?.key,
      parentId: selectedProject.value?.parentId
    }
    const eventData = {
      rootProject: _rootProject,
      project: _project,
      tag: null
    }

    emits('update:project', eventData.project)
    emits('update:tag', null)

  } else {
    const eventData = {
      rootProject: _rootProject,
      project: null,
      tag: null
    }
    gmTags.value = []
    emits('update:project', eventData.project)
    emits('update:tag', null)
  }
}

function handleTagChange(event: DropdownChangeEvent) {
  if (event.value) {

    const _rootProject = {
      text: selectedRootProject.value?.text,
      id: selectedRootProject.value?.key
    }
    const _project = {
      text: selectedProject.value?.text,
      id: selectedProject.value?.key,
      parentId: selectedProject.value?.parentId
    }

    const _tag = {
      text: selectedTag.value?.text,
      id: selectedTag.value?.key,
      parentId: selectedTag.value?.parentId,

    }

    const eventData = {
      rootProject: _rootProject,
      project: _project,
      tag: _tag
    }
    emits('update:tag', eventData.tag)

  } else {

    emits('update:tag', null)

  }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _createTextVNode("Root project"),
          (__props.vualidate.rootProject.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(Dropdown), {
          class: _normalizeClass({'p-invalid':__props.vualidate.rootProject.$invalid && __props.submitted}),
          style: {"width":"16rem"},
          id: "GemProjectField:rootProject",
          modelValue: selectedRootProject.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedRootProject).value = $event)),
          options: gmRootProject.value,
          filter: true,
          e: "",
          filterFields: ['text'],
          autoFilterFocus: true,
          autoOptionFocus: false,
          optionLabel: "text",
          placeholder: "Select root project",
          onChange: handleRootProjectChange,
          showClear: true
        }, null, 8, ["class", "modelValue", "options"]),
        (__props.vualidate.rootProject.$invalid && __props.submitted)
          ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(__props.vualidate.rootProject.required.$message.replace('Value', 'Root project')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", _hoisted_8, [
          _createTextVNode("Project"),
          (__props.vualidate.project.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(Dropdown), {
          style: {"width":"16rem"},
          class: _normalizeClass({'p-invalid':__props.vualidate.project.$invalid && __props.submitted}),
          id: "GemProjectField:project",
          modelValue: selectedProject.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedProject).value = $event)),
          options: gmProject.value,
          filter: true,
          filterFields: ['text'],
          autoFilterFocus: true,
          autoOptionFocus: false,
          optionLabel: "text",
          placeholder: "Select project",
          onChange: handleProjectChange,
          showClear: true
        }, null, 8, ["class", "modelValue", "options"]),
        (__props.vualidate.project.$invalid && __props.submitted)
          ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(__props.vualidate.project.required.$message.replace('Value', 'Project')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_unref(Dropdown), {
          style: {"width":"16rem"},
          id: "GemProjectField:tags",
          modelValue: selectedTag.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedTag).value = $event)),
          options: gmTags.value,
          filter: true,
          filterFields: ['text'],
          autoFilterFocus: true,
          autoOptionFocus: false,
          optionLabel: "text",
          placeholder: "Select tag",
          onChange: handleTagChange,
          showClear: true
        }, null, 8, ["modelValue", "options"])
      ])
    ])
  ]))
}
}

})